import { render, staticRenderFns } from "./SubclientsPage.vue?vue&type=template&id=34a03613&scoped=true"
import script from "./SubclientsPage.vue?vue&type=script&lang=ts"
export * from "./SubclientsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a03613",
  null
  
)

export default component.exports